import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { GroupViewPage } from '../group-view/group-view';

@Component({
  selector: 'page-invite',
  templateUrl: 'invite.html'
})
export class InvitePage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  goToGroupView(params){
    if (!params) params = {};
    this.navCtrl.push(GroupViewPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/invite/invite.ts